import React, { useEffect, useRef } from "react";
import { motion, useAnimation } from "framer-motion";
import Lottie from "lottie-react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

import particlesGreen from "../../assets/lottie/Star Animation.json";
import particlesOrange from "../../assets/lottie/Star Animation.json";
import particlesRed from "../../assets/lottie/Star Animation.json";
import iconChart from "../../assets/lottie/Growth_Chart.json";
import iconSafe from "../../assets/lottie/Success.json";
import iconWarning from "../../assets/lottie/WarningAlert.json";
import iconFire from "../../assets/lottie/dangerALert.json";

import "./EnhancedSpeedometerTrustfull.scss";

ChartJS.register(ArcElement, Tooltip, Legend);

const EnhancedSpeedometerTrustfull = ({ score = 0 }: any) => {
  const needleRef = useRef(null);
  const controls = useAnimation();

  const level =
    score < 50 ? "low" : score < 52 ? "medium" : "high";

  // Needle rotation
  const rotation = (score / 100) * 180 - 90; // -90° (left) → +90° (right)
  useEffect(() => {
    controls.start({ rotate: rotation, transition: { duration: 1.2, ease: "easeOut" } });
  }, [rotation, controls]);

  const color =
    level === "high" ? "#10b981" : level === "medium" ? "#f59e0b" : "#ef4444";
  const particleAnim =
    level === "low" ? particlesRed : level === "medium" ? particlesOrange : particlesGreen;

  const data = {
    datasets: [
      {
        data: [score, 100 - score],
        backgroundColor: [color, "#e5e7eb"],
        borderWidth: 0,
        cutout: "75%",
        circumference: 180,
        rotation: 270,
      },
    ],
  };

  const options = {
    plugins: { legend: { display: false }, tooltip: { enabled: false } },
    animation: false,
  };

  const getIcon = () => {
    if (level === "low") return iconFire;
    if (level === "medium") return iconWarning;
    return iconSafe;
  };

  return (
    <div className={"EnhancedSpeedometerTrustfull"}>
      <div className="speedometer-card">
        <div className="speedometer-header">
          <Lottie animationData={iconChart} loop style={{ width: 40, height: 40 }} />
          <h3>SCORE DE CONFIANCE</h3>
        </div>

        <div className="speedometer-wrap">
          <div className="chart-container-2">
            <Doughnut data={data} options={options} />

            <motion.div
              ref={needleRef}
              className="needle"
              animate={controls}
              initial={{ rotate: -90 }}
            >
              <div className="needle-base"></div>
            </motion.div>

            <div className="score-display">
              <motion.span
                key={score}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ type: "spring", stiffness: 200 }}
              >
                {score}%
              </motion.span>
            </div>
          </div>
        </div>

        <div className="speedometer-footer">
          <div className={`risk-texts ${level}`}>
            <Lottie animationData={getIcon()} loop style={{ width: 86, height: 86 }} />
            <span>
            {level === "low"
              ? "Confiance faible"
              : level === "medium"
                ? "confiance moyen"
                : "confiance élevé"}
          </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnhancedSpeedometerTrustfull;
